
import { FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import { useVenueName } from '../hooks/useVenueName';
function Footer({panel, onResetCookies}) {
  const { name, loading } = useVenueName();
  if (loading){
    return
  }
return (
  
<footer className="p-6 bg-[#f4f4f4] text-gray-700">
  <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between gap-10">

  {/* Kontakt */}
    <div className="flex-1">
      <h2 className="font-bold text-lg mb-2 text-black">Kontakt</h2>
      <p className="text-sm font-bold mt-2">Telefon: 
        <a href="tel:+48576998254" className="ml-1 text-blue-600 hover:underline">
          +48 576 998 254
        </a>
      </p>
      <p className="flex items-center gap-2 mt-2 text-sm">
        <span className="font-bold">Instagram:</span>
        <a
          href='https://www.instagram.com/maciejglab.pl/'
          className="text-pink-600 hover:underline flex items-center gap-1 font-semibold"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram className='text-xl' />
          @maciejglab.pl
        </a>
      </p>
      <div className='gap-2 flex items-center'>
              <Link to={`/${name}/prywatnosc`} className="text-sm font-bold mt-2 underline">Prywatność </Link>
        <button
            onClick={onResetCookies}
            className="mt-3 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg text-sm"
        >
            Zmień zgodę na pliki cookies
        </button>
      </div>
    </div>

    {/* Prawa autorskie */}
    <div className="flex-1 text-sm">
      <p className="font-bold">© Maciej Głąb 2025</p>
      <p>
        Design and project by{" "}
        <a
          target="_blank"
          rel='noreferrer'
          className="underline"
          href="https://maciejglab.pl"
        >
          Maciejka
        </a>
      </p>
    </div>
  </div>
</footer>

);
}
export default Footer